module.exports = SharedDependencies.MobX['application'];